import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PolarisButtonComponent } from './components/button/s-polaris-button.component';
import { PolarisTextComponent } from './components/text/s-polaris-text.component';
import { PolarisProgressBarComponent } from './components/progress-bar/s-polaris-progress-bar.component';
import { PolarisProductThumbnailComponent } from './components/product-thumbnail/s-polaris-product-thumbnail.component';
import { PolarisBannerComponent } from './components/banner/s-polaris-banner.component';
import { PolarisSelectComponent } from './components/select/s-polaris-select.component';
import { PolarisTextFieldComponent } from './components/text-field/s-polaris-text-field.component';
import { PolarisDatePickerComponent } from './components/date-picker/s-polaris-date-picker.component';
import { PolarisChoiceListComponent } from './components/choice-list/s-polaris-choice-list.component';

const POLARIS_COMPONENTS = [
  PolarisButtonComponent,
  PolarisTextComponent,
  PolarisProgressBarComponent,
  PolarisProductThumbnailComponent,
  PolarisBannerComponent,
  PolarisSelectComponent,
  PolarisTextFieldComponent,
  PolarisDatePickerComponent,
  PolarisChoiceListComponent,
];

/**
 * Reusable Shopify-Polaris look-alike components for checkout-extension previews.
 * Import this module wherever a preview needs to render Shopify checkout UI.
 */
@NgModule({
  declarations: [...POLARIS_COMPONENTS],
  imports: [CommonModule],
  exports: [...POLARIS_COMPONENTS],
})
export class PolarisModule {}
